import {
  FETCH_ANALYTICS_SUMMARY_START,
  FETCH_ANALYTICS_SUMMARY_SUCCESS,
  FETCH_ANALYTICS_SUMMARY_FAILURE,
  FETCH_ACTIVITY_LOGS_START,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
  SET_ANALYTICS_FILTERS,
  FETCH_ALL_USERS_START,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILURE,
  FETCH_API_VOLUME_INTERVAL_REQUEST,
  FETCH_API_VOLUME_INTERVAL_SUCCESS,
  FETCH_API_VOLUME_INTERVAL_FAIL
} from '../action-type';

const initialState = {
  summaryData: {
    apiVolumeInterval: [],
    loadingApiVolumeInterval: false,
    system_health: null,
    top_endpoints: [],
    method_distribution: [],
    top_users: [],
  },
  logs: [],
  users: [],
  loadingSummary: false,
  loadingLogs: false,
  loadingUsers: false,
  error: null,
  filters: {},
  pagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 20,
    total: 0,
  },
};

const analyticsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ANALYTICS_SUMMARY_START:
      return {
        ...state,
        loadingSummary: true,
      };
    case FETCH_ANALYTICS_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        summaryData: payload,
        error: null,
      };
    case FETCH_ANALYTICS_SUMMARY_FAILURE:
      return {
        ...state,
        loadingSummary: false,
        error: payload,
      };
    case FETCH_ACTIVITY_LOGS_START:
      return {
        ...state,
        loadingLogs: true,
      };
    case FETCH_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        loadingLogs: false,
        logs: payload.data,
        pagination: {
          ...state.pagination,
          currentPage: payload.current_page,
          totalPages: payload.last_page,
          total: payload.total,
        },
        error: null,
      };
    case FETCH_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        loadingLogs: false,
        error: payload,
      };
    case SET_ANALYTICS_FILTERS:
      return {
        ...state,
        filters: payload,
      };
    case FETCH_ALL_USERS_START:
        return {
            ...state,
            loadingUsers: true,
        };
    case FETCH_ALL_USERS_SUCCESS:
        return {
            ...state,
            loadingUsers: false,
            users: payload,
            error: null,
        };
    case FETCH_ALL_USERS_FAILURE:
        return {
            ...state,
            loadingUsers: false,
            error: payload,
        };

        case FETCH_API_VOLUME_INTERVAL_REQUEST:
      return { ...state, loadingApiVolumeInterval: true };

    case FETCH_API_VOLUME_INTERVAL_SUCCESS:
      return {
        ...state,
        apiVolumeInterval: payload,
        loadingApiVolumeInterval: false,
      };

    case FETCH_API_VOLUME_INTERVAL_FAIL:
      return {
        ...state,
        loadingApiVolumeInterval: false,
      };
    default:
      return state;
  }
};

export default analyticsReducer;
